var map = {
	"./404/index.vue": "eEPP",
	"./VRShow/index.vue": "iMSj",
	"./achievements/index.vue": "H8GS",
	"./analysis/analysisData.vue": "ki4a",
	"./article/components/ChartContent.vue": "AiTK",
	"./article/components/ImageContent.vue": "2kzJ",
	"./article/components/ImageVRContent.vue": "2CCN",
	"./article/components/ImageVideoContent.vue": "O5Mp",
	"./article/components/ImageVideoVR.vue": "rdac",
	"./article/components/TextContent.vue": "LVjE",
	"./article/components/VRContent.vue": "NN9c",
	"./article/components/VideoContent.vue": "h+nX",
	"./article/index.vue": "otzP",
	"./bright/index.vue": "H5C/",
	"./brightDetail/index.vue": "TF5n",
	"./canonical/index.vue": "QlRZ",
	"./certificaTion/certification.vue": "9SMP",
	"./checKout/checkout.vue": "gZZz",
	"./common/commonList.vue": "Xs4Y",
	"./consult/detail.vue": "+DUM",
	"./consult/index.vue": "y2dv",
	"./dataAssemble/index.vue": "zSBW",
	"./detail/certificationDetail.vue": "9kDO",
	"./detail/cmaDetail.vue": "p2Pl",
	"./detail/cnasDetail.vue": "j5PW",
	"./detail/metroloyDetail.vue": "yucq",
	"./detail/newsDetail.vue": "7bUo",
	"./detail/standardDetail.vue": "Xs2B",
	"./detail/testDetail.vue": "qW9R",
	"./home/footer.vue": "aufV",
	"./home/home.vue": "i9LQ",
	"./home/index.vue": "T3Xm",
	"./home/mainContent.vue": "7+Bf",
	"./home/topNav.vue": "hEDO",
	"./industyNews/index.vue": "CMul",
	"./introduction/index.vue": "4/58",
	"./keySpecial/index.vue": "oj03",
	"./login/index.vue": "+BY4",
	"./majorProject/index.vue": "ibkr",
	"./metroloylist/metroloyList.vue": "lZ9u",
	"./newsTrends/index.vue": "dlzs",
	"./notice/index.vue": "/X05",
	"./oneStep/index.vue": "BvCq",
	"./project/detail.vue": "RblK",
	"./project/fruitDetail.vue": "7py4",
	"./project/index.vue": "JIQN",
	"./shisanwu/index.vue": "/Co9",
	"./standArd/standard.vue": "j67m",
	"./websiteSearch/index.vue": "b8Pl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hDiI";


//////////////////
// WEBPACK FOOTER
// ./src/layout ^\.\/.*\.vue$
// module id = hDiI
// module chunks = 1